import { useTranslation } from "react-i18next";
import { DateTime } from "luxon";

import BaseAvatar from "@/components_v2/Avatar/BaseAvatar";
import BaseButton from "@/components_v2/Button/BaseButton";
import {
  BUTTON_TARGETS,
  BUTTON_TYPES,
  BUTTON_VARIANTS,
} from "@/components_v2/Button/constants";
import { LiveSessionCardProps } from "@/domains/certifications/components/types";

import "./styles.css";

const DATE_FORMAT = "d MMM · HH:mm ZZZZ";

const initials = (name: string) =>
  name
    .split(" ")
    .slice(-2)
    .map((word) => word.charAt(0))
    .join("");

const LiveSessionCard = ({ session }: LiveSessionCardProps) => {
  const { t } = useTranslation();

  return (
    <article className="certification-card live-session-card flex flex-col gap-200">
      <span className="live-session-when body-xs-regular">
        {DateTime.fromISO(session.scheduledStart).toFormat(DATE_FORMAT)}
      </span>

      <h3 className="live-session-title body-m-medium">{session.title}</h3>

      {session.presenter && (
        <div className="flex items-center gap-200">
          <BaseAvatar label={initials(session.presenter.name)} />

          <div className="flex flex-col">
            <span className="live-session-presenter-name body-xs-regular">
              {session.presenter.name}
            </span>

            <span className="certification-muted body-xs-regular">
              {session.presenter.affiliation}
            </span>
          </div>
        </div>
      )}

      {session.joinUrl ? (
        <BaseButton
          className="live-session-register"
          type={BUTTON_TYPES.LINK}
          to={session.joinUrl}
          target={BUTTON_TARGETS.BLANK}
          variant={BUTTON_VARIANTS.TERTIARY}
          isFullWidth
        >
          {t("certification.labels.liveSessions.register")}
        </BaseButton>
      ) : (
        <span className="certification-muted body-xs-regular">
          {t("certification.labels.liveSessions.linkSoon")}
        </span>
      )}
    </article>
  );
};

export default LiveSessionCard;
